export class RateLimitHandledError extends Error {
  public constructor() {
    super("The rate-limit error was handled globally.");
    this.name = "RateLimitHandledError";
  }
}

export function isRequestAborted(error: unknown): boolean {
  return typeof error === "object" && error !== null && "name" in error && error.name === "AbortError";
}
